<template>
  <div
    v-if="!ratesLoading"
    class="page">
    <app-title
      :page="rate.name"
      :class="'grid-column-start-1 grid-column-span-3_sm grid-column-span-4_lg mb3'">
      <div slot="content">
        <div
          v-if="rate.description"
          class="measure font-size-4 mb1"><vue-markdown :source="rate.description">{{ rate.description }}</vue-markdown></div>
        <p
          v-else
          class="font-size-4 mb1">Set your goals, then click the boxes below to see the break down.</p>
        <button
          class="invisible-button"
          @click="$router.push({ name: 'simpleRateSettings' })">Edit rates</button>
      </div>
    </app-title>
    <section class="grid grid-columns-2 grid-columns-3_sm grid-columns-5_lg mb-margin">
      <lw-card
        :title="'Monthly rate'"
        :colour="'reverse'"
        :value="rate.monthRate"
        :unit="'/person/client'"
      />
      <lw-card
        :title="'Sprint rate'"
        :colour="'reverse'"
        :value="rate.sprintRate"
        :unit="'/person/client'"
      />
      <lw-card
        :title="'Weekly rate'"
        :colour="'reverse'"
        :value="rate.weekRate"
        :unit="'/person/client'"
      />
      <lw-card
        :title="'Day rate'"
        :colour="'reverse'"
        :value="rate.dayRate"
        :unit="'/person'"
      />
      <lw-card
        :title="'Hourly rate'"
        :colour="'reverse'"
        :value="rate.hourRate"
        :unit="'/person'"
      />
    </section>
    <transition
      name="slide-top"
      mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import page from '../mixins/page'
import VueMarkdown from 'vue-markdown'
import Card from '../livewires/Card'

export default {
  components: {
    lwCard: Card,
    vueMarkdown: VueMarkdown
  },
  mixins: [ page ],
  computed: {
    ...mapGetters([
      'organization',
      'ratesLoading'
    ]),
    rate () {
      return this.$store.getters.rateCard(this.page)
    }
  }
}
</script>
